// src/utils/appEventsUtils.js
// NOTE: App events logging is disabled in PocketBase version
// Events can be logged later via a custom endpoint if needed

import { detectOS, detectBrowser } from './deviceDetection';
import { isPWAInstalled, isStandalone, isMobile } from './pwaUtils';

const ANONYMOUS_ID_KEY = 'sense_anonymous_id';

/**
 * Генерирует UUID v4
 */
function generateUUID() {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) {
        return crypto.randomUUID();
    }

    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0;
        const v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}

/**
 * Получает или создаёт anonymous_id из localStorage.
 */
export function getOrCreateAnonymousId() {
    let anonymousId = localStorage.getItem(ANONYMOUS_ID_KEY);

    if (!anonymousId) {
        anonymousId = generateUUID();
        localStorage.setItem(ANONYMOUS_ID_KEY, anonymousId);
        console.log('[appEventsUtils] Created new anonymous_id:', anonymousId);
    }

    return anonymousId;
}

/**
 * Определяет тип устройства
 */
export function detectDeviceType() {
    const userAgent = navigator.userAgent.toLowerCase();

    const isTablet = /ipad|tablet|playbook|silk/i.test(userAgent) ||
        (userAgent.includes('android') && !userAgent.includes('mobile'));

    if (isTablet) {
        return 'tablet';
    }

    if (isMobile()) {
        return 'mobile';
    }

    return 'desktop';
}

/**
 * Проверяет, запущено ли приложение как PWA
 */
export function detectIsPWA() {
    return isPWAInstalled() || isStandalone();
}

/**
 * Собирает информацию об устройстве пользователя
 */
export function getDeviceInfo() {
    return {
        os: detectOS(),
        browser: detectBrowser(),
        device_type: detectDeviceType(),
        is_pwa: detectIsPWA()
    };
}

/**
 * Отправляет событие app_open (заглушка для PocketBase)
 */
export async function logAppOpen(userId, path = '/') {
    try {
        const anonymousId = getOrCreateAnonymousId();
        const deviceInfo = getDeviceInfo();

        console.log('[appEventsUtils] app_open event (not sent to PocketBase):', {
            event_type: 'app_open',
            user_id: userId || null,
            anonymous_id: anonymousId,
            path: path,
            ...deviceInfo
        });

        // TODO: Implement app events collection in PocketBase if needed
        return { success: true };

    } catch (err) {
        console.error('[appEventsUtils] Exception in logAppOpen:', err);
        return { success: false, error: err };
    }
}

/**
 * Отправляет произвольное событие (заглушка для PocketBase)
 */
export async function logEvent(eventType, userId, options = {}) {
    try {
        const { path = '/' } = options;
        const anonymousId = getOrCreateAnonymousId();
        const deviceInfo = getDeviceInfo();

        console.log(`[appEventsUtils] ${eventType} event (not sent to PocketBase):`, {
            event_type: eventType,
            user_id: userId || null,
            anonymous_id: anonymousId,
            path: path,
            ...deviceInfo
        });

        // TODO: Implement app events collection in PocketBase if needed
        return { success: true };

    } catch (err) {
        console.error(`[appEventsUtils] Exception in logEvent:`, err);
        return { success: false, error: err };
    }
}
